// import React and other necessary modules
import React, { useState, useEffect } from 'react';  
// import Google Chart component
import Chart from "react-google-charts";             
// import useTranslation hook for translations
import { useTranslation } from "react-i18next";   

// define GoogleCharts function component with props as input
function GoogleCharts(props) {    
  // create state variables for chart data and chart id                  
  const [chartsData, setChartsData] = useState([]); 
  const [graphId, setGraphId] = useState(props.id);
  // use useTranslation hook to get access to i18n translation functions
  const { t } = useTranslation();                   

  // use useEffect hook to populate the chart data
  useEffect(() => {                                 
    populateChartData();
  }, []);

  // define a function to populate the chart data
  function populateChartData() {          
    // define the columns for the chart           
    const columns = [                                
      { type: "string", label: "Date" },
      { type: "number", label: "Yr-over-Yr % Vol Growth" },
      { type: "number", label: "Yr-over-Yr % Txn Growth" },
      { type: "number", label: "Yr-over-Yr % Vol Growth AVG" },
      { type: "number", label: "Yr-over-Yr % Txn Growth AVG" }
    ];

    // create an empty array to store the chart data rows
    let dataRows = [];      
    // get the chart data from the props                        
    let data = props.data;                     
    // loop through the data and push each row to the dataRows array     
    for (let i = 0; i < data.length; i++) {          
      let para_arr = [];
      para_arr.push(data[i]['new_start_date_Event'] ? data[i]['new_start_date_Event'] : "0")
      para_arr.push(data[i]['VolGrowth'] ? data[i]['VolGrowth'] : 0)
      para_arr.push(data[i]['TxnGrowth'] ? data[i]['TxnGrowth'] : 0)
      para_arr.push(data[i]['VolGrowthAVG'] ? data[i]['VolGrowthAVG'] : 0)
      para_arr.push(data[i]['TxnGrowthAVG'] ? data[i]['TxnGrowthAVG'] : 0)
      dataRows.push(para_arr);
    }
    // create an array of data to be used in the chart
    let resultData = [columns, ...dataRows];        
    // update the state variable for chart data with the new data
    setChartsData(resultData);                      
  }

  return (
    <div>
      {/* render the Chart component from Google Charts library */}
      <Chart          
        chartType="LineChart"                      
        data={chartsData}                            
        loader={<div>{t('Loading National Consumer Spending Trends Chart')}</div>}  
        graphID={graphId}                            
        width="100%"                                
        height="450px"                              
        options={{                                  
          title: '',
          legend: {
                  position: 'top'
                },
          hAxis: {
            format: 'dd/MM/yy'           
          },
          vAxis: {
            format:'#%'
          },
          series: {
            2: {
              lineDashStyle: [4, 4]
            },
            3: {
              lineDashStyle: [4, 4]
            }
          },
        }}
      />
    </div>
  );
}

export default GoogleCharts;